import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-crear-file',
  imports: [],
  templateUrl: './dialog-crear-file.component.html',
  styleUrl: './dialog-crear-file.component.scss'
})
export class DialogCrearFileComponent {

}
